import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import Loader from './components/Loader';

// ----------------------------------------------------------------------

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    setLoading(false);
  }, []);
  // const navigate = useNavigate();
  // const auth = JSON.parse(localStorage.getItem("globalUser") || sessionStorage.getItem("globalUser"))
  // useEffect(() => {
  //   // if(!auth && !auth.access) {
  //   if (!auth) {
  //     <Routes>
  //       <Route exact path="/" component={Login} />
  //       <Route exact path="/register" component={Register} />
  //     </Routes>
  //   }
  //   // else {
  //   //   navigate("/dashboard/app")
  //   // }
  //   //  navigate("/login") 
  // }, [navigate]);
  // // console.log("this is the auth: ", auth)

  if (loading) {
    return <Loader />;
  }
  
  return (
    <ThemeProvider>
      <ScrollToTop />
      <BaseOptionChartStyle />
      <Router />
      <ToastContainer limit={1} autoClose={1000} />
    </ThemeProvider>
  );
}
